
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  defineComponent, inject, onMounted, reactive, watch,
} from 'vue';
import {
  Form, InputNumber, Select, Button, Input, Radio, message,
} from 'ant-design-vue';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons-vue';
import Editor from '@/components/Editor.vue';
import WangEditor from 'wangeditor';
import { ParseQuestionI } from './js/interface';

export default defineComponent({
  name: 'Blank',
  components: {
    Editor,
    aForm: Form,
    aFormItem: Form.Item,
    aInput: Input,
    aInputNumber: InputNumber,
    aTextArea: Input.TextArea,
    aSelect: Select,
    aOption: Select.Option,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    PlusOutlined,
    DeleteOutlined,
    aButton: Button,
  },
  emits: ['emit-validate'],
  setup(props, { emit }) {
    const dataClone = inject('dataClone') as ParseQuestionI;

    watch(() => dataClone, (data) => {
      Object.assign(dataClone, data);
    }, { deep: true });

    const isChecked = (metaIndex: number) => dataClone.pAnswer.findIndex((d: any) => d === metaIndex) > -1;

    const handleCheckboxChange = (metaIndex: number) => {
      const i = (dataClone.pAnswer as number[]).indexOf(metaIndex);
      if (isChecked(metaIndex)) {
        (dataClone.pAnswer as number[]).splice(i, 1);
      } else {
        (dataClone.pAnswer as number[]).push(metaIndex);
      }
    };
    const stemEditor = reactive({}) as WangEditor;
    const analyEditor = reactive({}) as WangEditor;
    const answerEditor = reactive({}) as WangEditor;
    const validate = () => {
      // if (!stemEditor.txt.text().length) {
      //   message.error('题目输入字数不满足限制，请重新输入！');
      //   return false;
      // }
      if (dataClone.stem.length > 100 || dataClone.stem.length <= 0) {
        message.error('题目字数为1~100！');
        return false;
      }
      if (!answerEditor.txt.text().length) {
        message.error('参考答案输入字数不满足限制，请重新输入！');
        return false;
      }
      if (answerEditor.txt.text().length > 500) {
        message.error('解析最多输入500字数！');
        return false;
      }
      if (!analyEditor.txt.text().length) {
        message.error('解析输入字数不满足限制，请重新输入！');
        return false;
      }
      if (analyEditor.txt.text().length > 2000) {
        message.error('解析最多输入2000字数！');
        return false;
      }
      return true;
    };

    onMounted(() => {
      if (!dataClone.pAnswer.length) dataClone.pAnswer = [''];
      emit('emit-validate', validate);
    });

    const onEditorMounted = (index: number, editor: WangEditor) => {
      if (index === 0) Object.assign(stemEditor, reactive(editor) as WangEditor);
      if (index === 1) Object.assign(analyEditor, reactive(editor) as WangEditor);
      if (index === 2) Object.assign(answerEditor, reactive(editor) as WangEditor);
    };

    return {
      dataClone,
      isChecked,
      handleCheckboxChange,
      onEditorMounted,
    };
  },
});
